import { CSSProperties, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { faSidebar } from "@fortawesome/pro-regular-svg-icons";

import { translationKeys } from "../../../models/app-translation-keys";
import { useStore } from "../../../stores/StoreContext";
import { ActionButton } from "../Buttons";

interface ISidebarToggleButtonProps {
  customStyles?: CSSProperties;
  hide?: boolean;
  onClick: () => void;
}

const RawSidebarToggleButton: FunctionComponent<ISidebarToggleButtonProps> = (props: ISidebarToggleButtonProps) => {
  const { t } = useTranslation();
  const { sidebarStore, navigationStore } = useStore();

  const showTooltipKey =
    navigationStore.currentActiveMenuItem?.showSidebarTooltipKey || translationKeys.tooltip.showSidebar;
  const hideTooltipKey =
    navigationStore.currentActiveMenuItem?.hideSidebarTooltipKey || translationKeys.tooltip.hideSidebar;

  if (props.hide) {
    return;
  }

  return (
    <ActionButton
      icon={faSidebar}
      hideBackground={true}
      onClick={props.onClick}
      customStyles={props.customStyles}
      tooltip={t(sidebarStore.isCollapsed ? showTooltipKey : hideTooltipKey)}
    />
  );
};

export const SidebarToggleButton = observer(RawSidebarToggleButton);
